module.exports = __webpack_public_path__ + "static/media/what-is-crypto-portfolio-tracker.eee1ae46.md";


//////////////////
// WEBPACK FOOTER
// ./src/blog/what-is-crypto-portfolio-tracker.md
// module id = 766
// module chunks = 0